import * as actionTypes from "constants/actionTypes";

const initialState = {
  synced: false,
  status: {}
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REPLACE_SYSTEM_STATUS:
      return {
        synced: true,
        status: action.payload
      };
    default:
      return state;
  }
}

export const selectSystemStatus = state => state.system.status.status;
